import { render, staticRenderFns } from "./Linkable.vue?vue&type=template&id=0bb6c1f3&"
import script from "./Linkable.vue?vue&type=script&lang=js&"
export * from "./Linkable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports